<template>
  <el-dialog
    :title="showTitle"
    :visible.sync="dialogVisible"
    width="480px"
    custom-class="book-course-dialog"
    :before-close="handleClosed"
  >
    <div class="book-course-content">
      <!-- 模版一 -->
      <template v-if="step === 0">
        <div class="book-course-name">
          <h3>课程名称</h3>
          <CourseSelector
            :selectedCourse="selectedCourse"
            :courses="courses"
            :isBatchBook="isBatchBook"
            @onChange="onCourseChange"
          />
        </div>
        <div class="book-course-time">
          <h3>选择上课时间</h3>
          <el-cascader
            :disabled="!durationGroups.length"
            popper-class="time-cascader-popper"
            separator="  "
            v-model="selectedTime"
            :options="formattedTimeOptions"
            :props="cascaderProps"
            placeholder="选择上课时间"
            clearable
            class="time-cascader"
          ></el-cascader>
          <div class="time-tip" v-if="timeTip">{{ timeTip }}</div>
        </div>
        <div class="dialog-footer">
          <el-button class="book-course-btn cancel-btn" @click="cancel">取消</el-button>
          <el-button
            class="book-course-btn confirm-btn"
            type="primary"
            @click="confirm"
            :disabled="!selectedTime.length"
          >
            确定预约
          </el-button>
        </div>
      </template>

      <template v-if="step === 1">
        <div class="comfirm-time-cont">
          <div>{{ `${showDayInfo}开始` }}</div>
          <div>{{ `${showDateInfo}上课` }}</div>
        </div>
        <div class="dialog-footer">
          <el-button class="book-course-btn cancel-btn" @click="cancelStep1">取消</el-button>
          <el-button class="book-course-btn confirm-btn" type="primary" @click="confirmStep1">
            确定预约
          </el-button>
        </div>
      </template>

      <template v-if="step === 2">
        <div class="book-success">
          <div class="book-success-icon">
            <img
              width="72"
              height="48"
              src="@/assets/images/member/book-course/book-success.png"
              alt="success"
            />
          </div>
          <div class="book-success-text">
            <div class="book-success-text-title">预约成功</div>
            <div class="book-success-text-desc">课程预约成功，请按时上课</div>
          </div>
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import CourseSelector from './CourseSelector';
import { BOOK_OPERATION, BOOK_FAIL_TYPE } from '../config';

export default {
  name: 'BookCourseDialog',
  customModifiers: {
    'click.debounce.300': 'confirm', // 添加延迟时间 300ms
  },
  components: {
    CourseSelector,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '预约上课时间',
    },
    courses: {
      type: Array,
      default: () => [],
    },
    selectedIndex: {
      type: Number,
      default: 0,
    },
    isBatchBook: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showTitle: this.title,
      step: 0,
      showDayInfo: '',
      showDateInfo: '',
      timeTip: '',
      dialogVisible: false,
      visible: false,
      selectedTime: [],
      cascaderProps: {
        expandTrigger: 'hover',
        checkStrictly: false,
        value: 'id',
        label: 'label',
      },
      // 示例数据，实际使用时会被覆盖
      timeOptions: [],
      selectedCourse: this.courses[this.selectedIndex] || {},
      durationGroups: [],
    };
  },
  computed: {
    formattedTimeOptions() {
      // 将durationGroups转换为cascader需要的格式
      return this.durationGroups.map((group) => {
        return {
          id: group.start_date.toString(),
          label: group.start_date_des,
          children: group.cycle_durations.map((duration, i) => {
            return {
              id: `${duration.cycle}*${duration.start_time}*${duration.end_time}*${i}`,
              label: `${duration.cycle_des} ${duration.time_des}`,
              timeData: {
                cycle: duration.cycle,
                cycle_des: duration.cycle_des,
                end_time: duration.end_time,
                start_time: duration.start_time,
                time_des: duration.time_des,
              },
            };
          }),
        };
      });
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        // 使用nextTick确保DOM更新后再显示对话框，保留动画效果
        if (val) {
          this.$nextTick(() => {
            this.dialogVisible = true;
            this.$webSeeSendTrack({
              event_id: 'appointment_study_page_show',
              data: {
                course_id: this.selectedCourse.course_id,
                isBatchBook: this.isBatchBook,
              },
            });
          });
        }
      },
    },
    selectedCourse: {
      immediate: true,
      async handler(val) {
        // 获取批量预约时间
        this.getDurationGroups(val);
      },
    },
    selectedTime: {
      handler() {
        this.$webSeeSendTrack({
          event_id: 'course_time_select_click',
          event_type: 'click',
        });
      },
    },
  },
  methods: {
    async getDurationGroups(course) {
      // 不需要返回预约课程，0 不需要，1 需要
      const needUnAppointed = 0;
      const res = await this.$http.get('/backend-api/app/study/appointment/batch/duration', {
        courseId: course.course_id,
        needUnAppointed,
      });
      // test data
      this.timeTip = '';
      this.durationGroups = res.duration_groups;
      if (!this.durationGroups.length) {
        this.timeTip = '当前课程没有可预约的时间段';
      } else {
        this.timeTip = '';
      }
    },
    onCourseChange(course) {
      this.selectedCourse = course;
      this.selectedTime = [];
      this.$webSeeSendTrack({
        event_id: 'course_switch_button_click',
        event_type: 'click',
        data: {
          course_id: this.selectedCourse.course_id,
        },
      });
    },
    handleClosed() {
      switch (this.step) {
        case 0:
          this.$emit('update:show', false);
          // done();
          break;
        case 1:
          this.cancelStep1();
          break;
        case 2:
          this.$emit('update:show', false);
          break;
        default:
          this.$emit('update:show', false);
          break;
      }
      return false;
    },
    cancel() {
      // this.dialogVisible = false;
      this.$emit('update:show', false);
    },
    cancelStep1() {
      this.step = 0;
      this.showTitle = this.title;
    },
    async confirmStep1() {
      const res = await this.$http.post('/backend-api/app/study/appointment/batch', {
        ...this.postBody,
        operation: BOOK_OPERATION.BOOK,
      });
      // test data
      // const res = {
      //   fail_des: '周五 18:30-19:30',
      //   //
      //   fail_type: BOOK_FAIL_TYPE.NO_FAIL,
      // };
      if (res.fail_type === BOOK_FAIL_TYPE.NO_FAIL) {
        this.step = 2;
        this.showTitle = '预约上课时间';
        this.$emit('bookSuccess');
      }
    },
    async confirm() {
      if (!this.selectedTime.length) return;

      const [startDateId, combinValue] = this.selectedTime;
      // 查找选中的开始日期组和周期
      const startDateGroup = this.durationGroups.find(
        (group) => group.start_date.toString() === startDateId,
      );
      const cycleDuration = startDateGroup?.cycle_durations.find(
        (duration, i) =>
          `${duration.cycle}*${duration.start_time}*${duration.end_time}*${i}` === combinValue,
      );
      const [cycle] = combinValue.split('*');
      this.postBody = {
        course_id: this.selectedCourse.course_id,
        start_date: parseInt(startDateId),
        cycle,
        operation: BOOK_OPERATION.PRE_VALIDATE,
        end_time: cycleDuration.end_time,
        start_time: cycleDuration.start_time,
      };
      const res = await this.$http.post('/backend-api/app/study/appointment/batch', this.postBody);
      if (res.fail_type === BOOK_FAIL_TYPE.NO_FAIL) {
        this.timeTip = '';
        // 显示确认时间弹框
        this.step = 1;
        this.showDayInfo = startDateGroup.start_date_des;
        this.showDateInfo = `${cycleDuration.cycle_des}${cycleDuration.time_des}`;
        this.showTitle = '确定上课时间';
      } else if (res.fail_type === BOOK_FAIL_TYPE.TIME_CONFLICT) {
        this.timeTip = `${res.fail_des} 您有其他课节上课，请更换时间`;
      } else {
        this.timeTip = '课程已开始无法预约全部上课时间';
      }
      this.$webSeeSendTrack({
        event_id: 'appointment_study_makeSure',
        event_type: 'click',
        data: {
          ...this.postBody,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .book-course-dialog {
  padding: 24px;
  border-radius: 16px !important;

  .time-cascader .el-input .el-input__inner {
    // background-color: #fafafa;
    height: 48px;
    border-radius: 8px;
    color: #1d1b20;
  }
  .time-cascader .el-input.is-disabled .el-input__inner {
    background-color: #fafafa;
  }
  .time-cascader {
    .el-input__suffix {
      right: 10px;
      .el-input__icon {
        font-weight: 900;
        color: #a6a6b1;
      }
    }
  }

  .el-dialog__header {
    padding-top: 0;
    text-align: center;
    padding-bottom: 0;
    margin-bottom: 16px;
    font-weight: bolder;
  }

  .el-dialog__body {
    padding: 0;
    max-height: 486px;
  }
  .el-dialog__headerbtn {
    top: 25px;
  }
  .el-dialog__close.el-icon.el-icon-close {
    color: #54535c;
  }

  .book-course-content h3 {
    padding: 0;
    margin: 0;
    font-size: 16px;
    color: #1e1c22;
    line-height: 22px;
    margin-bottom: 8px;
  }
  .book-course-name {
    margin-bottom: 30px;
  }
  .book-course-time {
    .time-tip {
      margin-top: 4px;
      position: absolute;
      font-size: 12px;
      color: #ff2020;
      line-height: 22px;
    }
  }

  .comfirm-time-cont {
    padding-top: 43px;
    padding-bottom: 11px;
    font-size: 16px;
    line-height: 22px;
    color: #35333a;
    text-align: center;
  }

  .book-success {
    text-align: center;
    padding-top: 42px;
    padding-bottom: 42px;
    font-size: 16px;
    line-height: 22px;
    color: #35333a;
    text-align: center;
    &-icon {
      margin-bottom: 16px;
      img {
        height: auto;
      }
    }
    &-text-title {
      line-height: 22px;
      font-size: 16px;
      font-weight: bolder;
      line-height: 32px;
      color: #1d1b20;
      margin-bottom: 8px;
    }
    &-text-desc {
      line-height: 20px;
      font-size: 14px;
      color: #8c8b97;
    }
  }
}

.time-cascader {
  width: 100%;
}

.dialog-footer {
  margin-top: 48px;
  text-align: right;

  .book-course-btn {
    padding: 14px 24px;
    font-size: 14px;
    border-radius: 40px;
  }
  .confirm-btn {
    background-color: #ff2020;
    border: none;
    box-shadow: 0px 0px 4px -2px rgba(24, 39, 75, 0.12), 0px 0px 4px -2px rgba(24, 39, 75, 0.08);
    &:hover {
      background-color: #e50000;
    }
  }
  .cancel-btn {
    width: 104px;
    color: #706e79;
    box-sizing: border-box;
    border: 1px solid #e1e2e9;
    box-shadow: 0px 0px 4px -2px rgba(24, 39, 75, 0.12), 0px 0px 4px -2px rgba(24, 39, 75, 0.08);
    border: 1px solid #e1e2e9;
    &:hover {
      background-color: #ffffff;
      color: #706e79;
    }
  }
  ::v-deep .el-button.is-disabled:not(.el-button--text),
  .el-button.is-disabled:focus:not(.el-button--text),
  .el-button.is-disabled:hover:not(.el-button--text) {
    background-color: #fcc !important;
    border: none !important;
    color: #fff !important;
    box-shadow: 0px 0px 4px -2px rgba(24, 39, 75, 0.12), 0px 0px 4px -2px rgba(24, 39, 75, 0.08);
  }
}
</style>

<style lang="scss">
/* 全局样式，不使用scoped，确保能影响弹出的popper */
.time-cascader-popper {
  min-width: 432px !important;
  width: 432px !important;
  box-sizing: border-box;
  margin-top: 4px !important;
  border-radius: 8px !important;
}

.time-cascader-popper {
  .el-cascader-node.in-active-path,
  .el-cascader-node.is-active {
    background-color: #ffefef;
  }
  // .el-cascader-node:not(.is-disabled):hover,
  // .el-cascader-node:not(.is-disabled):focus {
  //   background-color: #fafafa;
  //   color: #26212f;
  //   font-weight: 500;
  // }
  .el-cascader-node:not(.is-active):not(.in-active-path):hover,
  .el-cascader-node:not(.is-active):not(.in-active-path):focus {
    background-color: #fafafa;
    color: #26212f;
    font-weight: 500;
  }
}
.time-cascader-popper .el-cascader-menu {
  // width: 50%;
  box-sizing: border-box;
  color: #26212f;
  padding: 8px;
  border-right: 1px solid #f1f3f9;
  .el-cascader-node {
    border-radius: 4px;
    padding: 0;
  }
  .el-cascader-node__label {
    padding: 0 8px;
  }
}

.time-cascader-popper .el-cascader-panel .el-cascader-menu:nth-child(1) {
  width: 44.3%;
}
.time-cascader-popper .el-cascader-panel .el-cascader-menu:nth-child(2) {
  width: 55.7%;
}

.time-cascader-popper .popper__arrow {
  display: none;
}
</style>
